import React from 'react'
import { useSelector } from 'react-redux'

import { MIXPANEL_PROPERTY } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/mixpanelConstants'
import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'
import { AppContext } from '@lyrahealth-inc/ui-core-crossplatform/src/context'

import { track } from '../../../mixpanel/mixpanelTracking'
import { getAuthConfig } from '../data/auth/authSelectors'

/*
ApplicationContext is used to add context to ui-core-crossplatform
*/
function ApplicationContext({ children }: { children: React.ReactNode }) {
  const trackEvent = (event: string, eventProps?: { [key in MIXPANEL_PROPERTY]?: any }) => {
    track({
      event,
      action: eventProps?.action,
      properties: eventProps,
    })
  }
  const config = useSelector(getAuthConfig)
  const {
    isExpandableWorkingHoursEnabled,
    isInProductCalendarAddModalEnabled,
    shouldShowMessengerDraftsUtility,
    isAiCoachEnabled,
    isLegacyProviderScheduleSessionEnabled,
  } = useFlags()
  return (
    <AppContext.Provider
      value={{
        trackEvent,
        isExpandableWorkingHoursEnabled,
        isInProductCalendarAddModalEnabled,
        shouldShowMessengerDraftsUtility,
        showAiCoach: isAiCoachEnabled,
        showCalendarScheduleSession: config?.inProductCalendar?.showCalendarScheduleSession,
        showLegacyScheduleSession:
          isLegacyProviderScheduleSessionEnabled && config?.inProductCalendar?.showLegacyScheduleSession,
      }}
    >
      {children}
    </AppContext.Provider>
  )
}

export default ApplicationContext
